import { render } from "./NavbarApp.vue?vue&type=template&id=5caf17aa"
import script from "./NavbarApp.vue?vue&type=script&lang=js"
export * from "./NavbarApp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__